var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 258.89 258.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2,\n      .cls-3 {\n        fill: none;\n      }\n      .cls-2 {\n        clip-rule: evenodd;\n      }\n      .cls-10,\n      .cls-11,\n      .cls-12,\n      .cls-13,\n      .cls-14,\n      .cls-16,\n      .cls-17,\n      .cls-18,\n      .cls-19,\n      .cls-20,\n      .cls-21,\n      .cls-22,\n      .cls-23,\n      .cls-24,\n      .cls-26,\n      .cls-27,\n      .cls-28,\n      .cls-29,\n      .cls-3,\n      .cls-30,\n      .cls-31,\n      .cls-32,\n      .cls-33,\n      .cls-34,\n      .cls-6,\n      .cls-7,\n      .cls-8,\n      .cls-9 {\n        fill-rule: evenodd;\n      }\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n      .cls-5 {\n        clip-path: url(#clip-path-2);\n      }\n      .cls-6 {\n        fill: #e50000;\n      }\n      .cls-7 {\n        fill: #e81210;\n      }\n      .cls-8 {\n        fill: #ec231f;\n      }\n      .cls-9 {\n        fill: #ef352f;\n      }\n      .cls-10 {\n        fill: #f2463f;\n      }\n      .cls-11 {\n        fill: #f5584e;\n      }\n      .cls-12 {\n        fill: #f9695e;\n      }\n      .cls-13 {\n        fill: #fc7b6d;\n      }\n      .cls-14 {\n        fill: #ff8c7d;\n      }\n      .cls-15 {\n        clip-path: url(#clip-path-3);\n      }\n      .cls-16 {\n        fill: #ffb900;\n      }\n      .cls-17 {\n        fill: #ffc104;\n      }\n      .cls-18 {\n        fill: #ffc808;\n      }\n      .cls-19 {\n        fill: #ffd00b;\n      }\n      .cls-20 {\n        fill: #ffd70f;\n      }\n      .cls-21 {\n        fill: #ffdf13;\n      }\n      .cls-22 {\n        fill: #ffe616;\n      }\n      .cls-23 {\n        fill: #ffee1a;\n      }\n      .cls-24 {\n        fill: #fff51e;\n      }\n      .cls-25 {\n        clip-path: url(#clip-path-5);\n      }\n      .cls-26 {\n        fill: #0fb300;\n      }\n      .cls-27 {\n        fill: #24bb00;\n      }\n      .cls-28 {\n        fill: #39c300;\n      }\n      .cls-29 {\n        fill: #4ecb00;\n      }\n      .cls-30 {\n        fill: #63d300;\n      }\n      .cls-31 {\n        fill: #77da00;\n      }\n      .cls-32 {\n        fill: #8ce200;\n      }\n      .cls-33 {\n        fill: #a1ea00;\n      }\n      .cls-34 {\n        fill: #b6f200;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.45,129.45,17.34,194.17A129.45,129.45,0,0,1,129.45,0V129.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.45,15.9C216.5,15.9,243,42.39,243,129.45S216.5,243,129.45,243,15.9,216.5,15.9,129.45,42.39,15.9,129.45,15.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.45,129.45V0a129.45,129.45,0,0,1,112.1,194.17l-112.1-64.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.45,129.45l112.1,64.72a129.45,129.45,0,0,1-224.21,0l112.11-64.72Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.45,0A129.45,129.45,0,1,1,0,129.45,129.44,129.44,0,0,1,129.45,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.45,15.9C216.5,15.9,243,42.39,243,129.45S216.5,243,129.45,243,15.9,216.5,15.9,129.45,42.39,15.9,129.45,15.9Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.45,25.36c78.78,0,104.08,25.3,104.08,104.09s-25.3,104.08-104.08,104.08S25.36,208.23,25.36,129.45,50.66,25.36,129.45,25.36Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.45,34.82c70.51,0,94.62,24.11,94.62,94.63S200,224.07,129.45,224.07,34.82,200,34.82,129.45s24.11-94.63,94.63-94.63Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M129.45,44.28c62.24,0,85.16,22.92,85.16,85.17s-22.92,85.16-85.16,85.16-85.17-22.92-85.17-85.16S67.2,44.28,129.45,44.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.45,53.75c54,0,75.69,21.72,75.69,75.7s-21.72,75.69-75.69,75.69-75.7-21.72-75.7-75.69,21.72-75.7,75.7-75.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M129.45,63.21c45.7,0,66.23,20.53,66.23,66.24s-20.53,66.23-66.23,66.23-66.24-20.53-66.24-66.23,20.53-66.24,66.24-66.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M129.45,72.67c37.44,0,56.77,19.33,56.77,56.78s-19.33,56.77-56.77,56.77-56.78-19.33-56.78-56.77S92,72.67,129.45,72.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M129.45,82.13c29.17,0,47.31,18.14,47.31,47.32s-18.14,47.31-47.31,47.31-47.32-18.14-47.32-47.31,18.14-47.32,47.32-47.32Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M129.45,91.6A37.85,37.85,0,1,1,91.6,129.45,37.84,37.84,0,0,1,129.45,91.6Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M129.45,0A129.45,129.45,0,1,1,0,129.45,129.44,129.44,0,0,1,129.45,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M129.45,15.9C216.5,15.9,243,42.39,243,129.45S216.5,243,129.45,243,15.9,216.5,15.9,129.45,42.39,15.9,129.45,15.9Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M129.45,25.36c78.78,0,104.08,25.3,104.08,104.09s-25.3,104.08-104.08,104.08S25.36,208.23,25.36,129.45,50.66,25.36,129.45,25.36Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M129.45,34.82c70.51,0,94.62,24.11,94.62,94.63S200,224.07,129.45,224.07,34.82,200,34.82,129.45s24.11-94.63,94.63-94.63Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M129.45,44.28c62.24,0,85.16,22.92,85.16,85.17s-22.92,85.16-85.16,85.16-85.17-22.92-85.17-85.16S67.2,44.28,129.45,44.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M129.45,53.75c54,0,75.69,21.72,75.69,75.7s-21.72,75.69-75.69,75.69-75.7-21.72-75.7-75.69,21.72-75.7,75.7-75.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M129.45,63.21c45.7,0,66.23,20.53,66.23,66.24s-20.53,66.23-66.23,66.23-66.24-20.53-66.24-66.23,20.53-66.24,66.24-66.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M129.45,72.67c37.44,0,56.77,19.33,56.77,56.78s-19.33,56.77-56.77,56.77-56.78-19.33-56.78-56.77S92,72.67,129.45,72.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M129.45,82.13c29.17,0,47.31,18.14,47.31,47.32s-18.14,47.31-47.31,47.31-47.32-18.14-47.32-47.31,18.14-47.32,47.32-47.32Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M129.45,91.6A37.85,37.85,0,1,1,91.6,129.45,37.84,37.84,0,0,1,129.45,91.6Z",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M129.45,0A129.45,129.45,0,1,1,0,129.45,129.44,129.44,0,0,1,129.45,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M129.45,15.9C216.5,15.9,243,42.39,243,129.45S216.5,243,129.45,243,15.9,216.5,15.9,129.45,42.39,15.9,129.45,15.9Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M129.45,25.36c78.78,0,104.08,25.3,104.08,104.09s-25.3,104.08-104.08,104.08S25.36,208.23,25.36,129.45,50.66,25.36,129.45,25.36Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M129.45,34.82c70.51,0,94.62,24.11,94.62,94.63S200,224.07,129.45,224.07,34.82,200,34.82,129.45s24.11-94.63,94.63-94.63Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M129.45,44.28c62.24,0,85.16,22.92,85.16,85.17s-22.92,85.16-85.16,85.16-85.17-22.92-85.17-85.16S67.2,44.28,129.45,44.28Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M129.45,53.75c54,0,75.69,21.72,75.69,75.7s-21.72,75.69-75.69,75.69-75.7-21.72-75.7-75.69,21.72-75.7,75.7-75.7Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M129.45,63.21c45.7,0,66.23,20.53,66.23,66.24s-20.53,66.23-66.23,66.23-66.24-20.53-66.24-66.23,20.53-66.24,66.24-66.24Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M129.45,72.67c37.44,0,56.77,19.33,56.77,56.78s-19.33,56.77-56.77,56.77-56.78-19.33-56.78-56.77S92,72.67,129.45,72.67Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M129.45,82.13c29.17,0,47.31,18.14,47.31,47.32s-18.14,47.31-47.31,47.31-47.32-18.14-47.32-47.31,18.14-47.32,47.32-47.32Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M129.45,91.6A37.85,37.85,0,1,1,91.6,129.45,37.84,37.84,0,0,1,129.45,91.6Z",
    transform: "translate(0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.df989ce2a71d7f500aeb33e8687bc823.svg";
export { ForwardRef as ReactComponent };